import Component from './tiktok_prize_dialog.vue'
export default Component
